import { ReactElement } from 'react';
import styles from './map-button.module.scss';
import { UIIcon } from '@/ui';
import { charcoal } from '@/ui/styles';
import { useTasksTranslation } from '../hooks';

type MapButtonProps = {
    onClick: () => void;
    selected?: boolean;
};
export function MapButton(props: MapButtonProps): ReactElement {
    const { onClick, selected } = props;
    const { t } = useTasksTranslation();

    const classNames = [styles.container];
    if (selected) {
        classNames.push(styles.selected);
    }
    return (
        <button
            onClick={onClick}
            className={classNames.join(' ')}
            aria-label={t('components.map_button.recentre_label')}
        >
            <UIIcon name="crosshair" size={24} color={charcoal} />
        </button>
    );
}
